import _ from 'lodash';
import { BrowserType } from '../types/enum';

export interface FormValue {
  value?: any;
  key: string;
  isValid?: boolean;
}

export const getValueFromKey = (key: string, formValues: FormValue[]) => {
  const value = formValues.find((value) => value.key === key);
  return value;
};

export const capitalizeFirstLetter = (str: string) => {
  return `${str[0].toUpperCase()}${str.slice(1)}`;
};

export const capitalizeOnlyFirstLetter = (str: string) => {
  return `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export const getDefaultOnNull = (value?: string) => (value ? value : '');

export const getBrowserType = () => {
  let isMobileBrowser = false;
  if ('maxTouchPoints' in navigator) {
    isMobileBrowser = navigator.maxTouchPoints > 0;
  } else {
    const mQ = matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      isMobileBrowser = !!mQ.matches;
    } else if ('orientation' in window) {
      isMobileBrowser = true;
    } else {
      //@ts-ignore
      const UA = navigator.userAgent;
      isMobileBrowser =
        /\b(BlackBerry|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad)\b/i.test(UA);
    }
  }
  if (isMobileBrowser) {
    return BrowserType.MOBILE;
  } else {
    return BrowserType.DESKTOP;
  }
};
